<template>
  <div class="intro-koets">
    <img
      :src="require('@/assets/images/city.png')"
      alt=""
      draggable="false"
      class="city"
    />
    <img
      :src="require('@/assets/images/koets.png')"
      alt=""
      draggable="false"
      class="koets"
    />
    <IntroChar />
  </div>
</template>

<script>
import { TweenMax } from 'gsap'
import IntroChar from './IntroChar'

export default {
  name: 'IntroKoets',
  components: {
    IntroChar
  },
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerElement: '.intro-koets',
      triggerHook: 'onEnter',
      duration: '200%',
      offset: 200
    })

    const tweenKoets = TweenMax.to('.koets', 1, { left: '80%' }, 0)
    this.$scrollmagic.addScene(scene.setTween(tweenKoets))
  }
}
</script>

<style lang="scss" scoped>
.intro-koets {
  position: relative;
  font-size: 0;
  height: 133px;
  width: 1144px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 1144px) {
    width: 100%;
  }
}

.city {
  height: 133px;
  position: absolute;
  bottom: 0;
  width: 1144px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;

  @media (min-width: 1144px) {
    width: 100%;
    height: auto;
  }
}

.koets {
  width: 150px;
  height: auto;
  position: absolute;
  z-index: 2;
  bottom: -20px;
  left: 0;
}
</style>
